export default __webpack_public_path__ + "static/media/logo-prefeitura.95a30620.svg";